import styled from 'styled-components'
import { MAX_CONTENT_WIDTH, APP_BAR_HEIGHT } from 'commons/constants/layout'

const MainContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  background-color: var(--background-secondary);
`
const Main = styled.main`
  width: 100%;
  flex-grow: 1;
  display: flex;
  max-width: ${MAX_CONTENT_WIDTH}px;
  align-self: center;
  padding-top: ${APP_BAR_HEIGHT}px;
  overflow: hidden;
  flex-direction: column;
  box-sizing: border-box;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding-left: 0;
    padding-right: 0;
    width: 100%;
    max-width: 100%;
  }
`

export { MainContainer, Main }
